import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./subjectsTour.css";

export function startSubjectFormTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giúp bạn đi qua các vùng quan trọng khi tạo/cập nhật môn học.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="subject-form-header"]',
      title: "Header form",
      description:
        "Xác định bạn đang thêm mới hay cập nhật môn học. Nút lấp lánh mở lại tour nhanh.",
      side: "bottom",
    },
    {
      selector: '[data-tour="subject-form-basic"]',
      title: "Thông tin cơ bản",
      description:
        "Nhập mã và tên môn học. Mã thường là định danh ngắn, viết hoa.",
      side: "right",
    },
    {
      selector: '[data-tour="subject-form-settings"]',
      title: "Cấu hình trạng thái",
      description:
        "Chọn trạng thái sử dụng và thứ tự hiển thị.",
      side: "right",
    },
    {
      selector: '[data-tour="subject-form-identity"]',
      title: "Nhận diện hiển thị",
      description:
        "Chọn icon và màu sắc để thẻ môn học nổi bật và dễ phân biệt.",
      side: "left",
    },
    {
      selector: '[data-tour="subject-form-description"]',
      title: "Mô tả chi tiết",
      description:
        "Bổ sung mô tả/ngữ cảnh để người dùng hiểu rõ phạm vi môn học.",
      side: "left",
    },
    {
      selector: '[data-tour="subject-form-actions"]',
      title: "Hành động lưu",
      description:
        "Bấm Lưu môn học để hoàn tất; hệ thống sẽ kiểm tra trường bắt buộc trước khi lưu.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy mở form rồi thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "subjects-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
